import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';

  slides = [
    {
      img: "/assets/img/slider/egypt-315x300.jpg",
      text: "Pamphlets in Egypt"
    },
    {
      img: "/assets/img/slider/envelope2-315x300.jpg",
      text: "Pamphlets in London"
    },
    { 
      img: "/assets/img/slider/IMG_5954-315x300.jpg",
      text: "\"I really thank you very much for all what you are doing for Islam\" - Br. Jihed, Tunisia"
    },
    { 
      img: "/assets/img/slider/business1-315x300.jpg",
      text: "Pamphlets at a restaurant counter bench"
    },
    { 
      img: "/assets/img/slider/dawah2-315x300.png",
      text: "\"I think what you're doing is really thoughtful and nice for the Muslim community\" - Zoubair, Canada"
    },
    { 
      img: "/assets/img/slider/pamphletsflowers-315x300.jpg",
      text: "\"MashAllaah you are doing a fantastic job... it is incredible how beautiful your pamphlets are!\" - Asma, Denmark"
    },
    { 
      img: "/assets/img/slider/table-315x300.jpg",
      text: "\"The pamphlets are amazing masha'Allah! May Allah reward you for the great work\" - Dino, Netherlands"
    },
    { 
      img: "/assets/img/slider/kuwait-315x300.jpg",
      text: "Pamphlets in Kuwait"
    },
    { 
      img: "/assets/img/slider/DSCF0038-315x300.jpg",
      text: "\"I want to give dawah like the Prophet (pbuh), inshaAllah these pamphlets will help\" - Mifdhal, Malaysia"
    },
    { 
      img: "/assets/img/slider/table1-315x300.jpg",
      text: "Dawah table in Melbourne, Australia"
    },
    { 
      img: "/assets/img/slider/spanish-315x300.jpg",
      text: "Pamphlet translated into Spanish"
    },
    { 
      img: "/assets/img/slider/8093104402_3c8ff99de0-315x300.jpg",
      text: "Pamphlet translated into the Sinhala language"
    },
    { 
      img: "/assets/img/slider/IMG_5954-315x300.jpg",
      text: "\"I will distribute your pamphlets to local non muslim friends for awareness about Islam\" - Mr. Firdaus, Saudi Arabia"
    },
    { 
      img: "/assets/img/slider/DSCF0022-315x300.jpg",
      text: "Specific pamphlet topics for Muslims and Non-Muslims"
    },
    { 
      img: "/assets/img/slider/streetdawah-315x300.jpg",
      text: "\"Alhamdulillah, our Islamic Center has selected 10 topics among several available on your website & printed them in thousands.\" - Abdul, India"
    },
    { 
      img: "/assets/img/slider/envelope2-315x300.jpg",
      text: "Pamphlets have been sent to over 50 countries"
    },
    { 
      img: "/assets/img/slider/street-315x300.jpg",
      text: "\"I am a new Muslim and I want to give out some pamphlets in my city\" - Kristin, USA"
    },
    { 
      img: "/assets/img/slider/IMG_5563-315x300.jpg",
      text: "\"I want to give to people here in China to spread Islam\" - Mr. Souheib, China"
    },
    { 
      img: "/assets/img/slider/dawah-315x300.png",
      text: "\"That's a great idea you are doing a FANTASTIC Job May Allah bless you for this work!\" - Kaya, France"
    },
    { 
      img: "/assets/img/slider/stock-315x300.jpg",
      text: "More than a million pamphlets have been printed since 2006, Alhamdulilah"
    },
    { 
      img: "/assets/img/slider/mail3-315x300.jpg",
      text: "Mailbox distribution... thousands of pamphlets distributed!"
    }
  ];
  
  slideConfig = {"slidesToShow": 1, "slidesToScroll": 1, "autoplay": true, "arrows": false};
  slickInit(e) {
    console.log('slick initialized');
  }
}
